import { Stack } from "@mui/material";

import images from "../../constants/images";

const FAQButton = () => {
  const handleHelp = () => {
    window.Telegram.WebApp.openLink(
      "https://telegra.ph/Token-Valley---Frequently-Asked-Questions-FAQ-03-31",
      {
        try_instant_view: true,
      },
    );
  };
  return (
    <Stack
      onClick={handleHelp}
      height={"100%"}
      padding={"5px"}
      border={"2px solid"}
      borderRadius={"25%"}
      alignItems={"center"}
      justifyContent={"center"}
      bgcolor={"primary.bgQuestionButton"}
      borderColor={"primary.borderDarkBlue"}
      boxShadow={
        "inset 0 8px 10px -6px #84C1FF, inset 0 -8px 10px -6px #0C81C5"
      }
    >
      <img
        alt="FAQ"
        src={images.icons.FAQ}
        style={{ width: "20px", height: "20px" }}
      />
    </Stack>
  );
};

export default FAQButton;
